import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { orderStatusConfig } from 'src/components/custom_components/orderStatusConfig';

import { OrderStatusEnum } from 'src/models/GalenData/Order.model';
import { I18NextNS } from 'src/models/Language.model';

const OrderStatusBadgeView = ({ status }: { status: OrderStatusEnum }) => {
  const { t } = useTranslation(I18NextNS.COMMON);
  const { color } = orderStatusConfig[status];

  return (
    <Badge pill bg={color}>
      {t(`orderFields.orderStatusEnum.${status}`)}
    </Badge>
  );
};

const OrderStatusBadge = (status: OrderStatusEnum) => (
  <OrderStatusBadgeView status={status} />
);

export default OrderStatusBadge;
